import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import logoImage from '../assets/images/logo.png';

const Nav = styled.nav<{ scrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  transition: all 0.3s ease-in-out;
  background-color: ${props => props.scrolled ? 'rgba(249, 243, 231, 0.9)' : 'transparent'};
  backdrop-filter: ${props => props.scrolled ? 'blur(10px)' : 'none'};
  box-shadow: ${props => props.scrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : 'none'};
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Logo = styled.div`
  font-weight: 700;
  font-size: 1.8rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  
  img {
    height: 80px;
    margin-right: 15px;
    transition: all 0.3s ease;
  }
  
  span {
    color: var(--accent-color);
  }
  
  @media (max-width: 768px) {
    img {
      height: 60px;
    }
  }
`;

const MenuItems = styled.ul<{ isOpen: boolean }>`
  display: flex;
  list-style: none;
  gap: 2rem;
  
  @media (max-width: 768px) {
    position: fixed;
    flex-direction: column;
    top: 0;
    right: 0;
    height: 100vh;
    width: 70%;
    background-color: var(--light-color);
    padding: 6rem 2rem;
    transform: ${props => props.isOpen ? 'translateX(0)' : 'translateX(100%)'};
    transition: transform 0.3s ease-in-out;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
    z-index: 90;
  }
`;

const MenuItem = styled.li`
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -5px;
    left: 0;
    background-color: var(--accent-color);
    transition: width 0.3s ease;
  }
  
  &:hover:after {
    width: 100%;
  }
`;

const NavLink = styled.a`
  color: var(--primary-color);
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--secondary-color);
  }
`;

const Hamburger = styled.div<{ isOpen: boolean }>`
  display: none;
  cursor: pointer;
  z-index: 100;
  
  div {
    width: 25px;
    height: 3px;
    background-color: var(--primary-color);
    margin: 5px;
    transition: all 0.3s ease;
  }
  
  div:nth-child(1) {
    transform: ${props => props.isOpen ? 'rotate(-45deg) translate(-5px, 6px)' : ''};
  }
  
  div:nth-child(2) {
    opacity: ${props => props.isOpen ? '0' : '1'};
  }
  
  div:nth-child(3) {
    transform: ${props => props.isOpen ? 'rotate(45deg) translate(-5px, -6px)' : ''};
  }
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <Nav scrolled={scrolled}>
      <NavContainer>
        <Logo>
          <img src={logoImage} alt="Flinstones RestoCafe" />
         
        </Logo>
        
        <Hamburger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
          <div></div>
          <div></div>
          <div></div>
        </Hamburger>
        
        <MenuItems isOpen={isOpen}>
          <MenuItem>
            <NavLink href="#home">Ana Sayfa</NavLink>
          </MenuItem>
          <MenuItem>
            <NavLink href="#about">Hakkımızda</NavLink>
          </MenuItem>
          <MenuItem>
            <NavLink href="#mobile-app">Mobil Uygulama</NavLink>
          </MenuItem>
          <MenuItem>
            <NavLink href="#contact">İletişim</NavLink>
          </MenuItem>
        </MenuItems>
      </NavContainer>
    </Nav>
  );
};

export default Navbar; 